import { Link } from 'react-router-dom';
import { useState } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import JsonLd from '@/components/feature/JsonLd';
import { categories, activities } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { faqData } from '@/mocks/faq';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '盛世娱乐',
  url: 'https://1616e.cn',
  description: '盛世娱乐是您首选的高端娱乐平台，汇聚丰富娱乐内容与专业服务。致力于为用户提供极致娱乐体验，涵盖多元化娱乐项目，安全可靠，畅享无限精彩。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9999',
    contactType: 'customer service',
    email: 'support@shengshientertainment.com',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '盛世娱乐官方平台',
  url: 'https://1616e.cn',
  description: '盛世娱乐是您首选的高端娱乐平台，汇聚丰富娱乐内容与专业服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://1616e.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      <SEOHead
        title="盛世娱乐官方平台——顶级娱乐体验尽在盛世 | 盛世娱乐官网"
        description="盛世娱乐是您首选的高端娱乐平台，汇聚丰富娱乐内容与专业服务。致力于为用户提供极致娱乐体验，涵盖多元化娱乐项目，安全可靠，畅享无限精彩。立即加入盛世娱乐，开启您的娱乐新世界。"
        keywords="盛世娱乐,盛世娱乐官网,盛世娱乐平台,盛世娱乐注册,盛世娱乐会员,盛世娱乐最新活动,盛世娱乐体验"
        canonicalUrl="https://1616e.cn/"
        ogTitle="盛世娱乐官方平台——顶级娱乐体验尽在盛世"
        ogDescription="盛世娱乐是您首选的高端娱乐平台，汇聚丰富娱乐内容与专业服务。安全可靠，畅享无限精彩。立即加入盛世娱乐，开启您的娱乐新世界。"
      />
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={faqSchema} />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20entertainment%20atmosphere%20with%20dramatic%20warm%20golden%20lighting%20from%20above%2C%20elegant%20abstract%20geometric%20patterns%20with%20gold%20and%20dark%20tones%2C%20premium%20velvet%20texture%20background%2C%20sophisticated%20casino%20ambiance%2C%20soft%20bokeh%20particles%2C%20refined%20luxurious%20aesthetic%20with%20deep%20blacks%20and%20rich%20golds&width=1800&height=900&seq=hero-shengshi-2026&orientation=landscape"
              alt="盛世娱乐高端娱乐平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          </div>

          <div className="relative z-10 w-full text-center px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-6xl font-bold font-heading text-background-50 mb-4 tracking-wide">
                盛世娱乐
              </h1>
              <p className="text-lg md:text-xl text-foreground-200 mb-2 font-light tracking-wider">
                顶级娱乐体验 · 尽在盛世
              </p>
              <p className="text-sm md:text-base text-foreground-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                汇聚全球顶尖娱乐内容，涵盖电子游艺、真人视讯、体育竞技、棋牌游戏、彩票游戏及电竞游戏。安全可靠，畅享无限精彩。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/about"
                  className="px-8 py-3.5 text-base font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即加入盛世
                </Link>
                <Link
                  to="/category/electronic-games"
                  className="px-8 py-3.5 text-base font-medium border-2 border-background-50/30 text-background-50 rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  探索娱乐项目
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-0 right-0 flex justify-center z-10">
            <div className="animate-bounce w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
            </div>
          </div>
        </section>

        {/* Features Bar */}
        <section className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { icon: 'ri-shield-check-line', label: '安全可靠', desc: '银行级加密保障' },
                { icon: 'ri-flashlight-line', label: '极速体验', desc: '毫秒级响应速度' },
                { icon: 'ri-customer-service-2-line', label: '专属客服', desc: '7×24小时在线' },
                { icon: 'ri-vip-crown-line', label: 'VIP特权', desc: '尊享会员礼遇' },
              ].map((feature) => (
                <div key={feature.label} className="flex items-center gap-3 p-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 flex-shrink-0">
                    <i className={`${feature.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{feature.label}</div>
                    <div className="text-xs text-foreground-500">{feature.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-16 md:py-20 bg-background-100/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                多元化娱乐项目
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                六大娱乐板块，满足您的所有需求。无论您偏好哪种娱乐方式，都能在这里找到属于自己的乐趣。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop="">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                    <div className="absolute bottom-3 left-4 right-4">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/90 flex-shrink-0">
                          <i className={`${cat.icon} text-background-50 text-sm`}></i>
                        </div>
                        <span className="text-background-50 font-semibold text-base">{cat.name}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-5">
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {cat.description}
                    </p>
                    <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                      <span>了解更多</span>
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Activities Section */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                最新活动
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                精彩活动不断，丰厚福利等你来拿。关注盛世娱乐最新动态，不错过每一个惊喜。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {activities.map((activity) => (
                <div
                  key={activity.id}
                  className="bg-background-50 rounded-xl border border-background-200/60 p-6 hover:border-primary-300/50 transition-all duration-300 relative overflow-hidden"
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full">
                      {activity.badge}
                    </span>
                    <span className="text-xs text-foreground-500">
                      截止: {activity.endDate}
                    </span>
                  </div>
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-3">
                    {activity.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {activity.description}
                  </p>
                  <div className="flex items-center gap-1 text-primary-500 text-sm font-medium cursor-pointer">
                    <span>查看详情</span>
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="py-16 md:py-20 bg-background-100/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-12">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  精选文章
                </h2>
                <p className="text-sm md:text-base text-foreground-600">
                  最新的娱乐资讯、技巧攻略与平台动态
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {articles.slice(0, 4).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs text-foreground-500">{article.date}</span>
                      <span className="text-xs text-foreground-500">·</span>
                      <span className="text-xs text-foreground-500">{article.readTime}</span>
                    </div>
                    <h3 className="text-sm font-bold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/category/electronic-games"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-background-50 border border-background-300/60 text-foreground-700 rounded-full hover:border-primary-300/50 hover:text-primary-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>查看全部文章</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 md:py-20 bg-background-50" id="faq">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                快速了解盛世娱乐，解答您的疑问
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {item.question}
                    </span>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </div>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}